module.exports = __webpack_public_path__ + "img/gartek-portfolio-global-markets.c1776f81.jpeg";